import { createClient } from '@supabase/supabase-js'
import { v4 as uuid } from '@lukeed/uuid';

const supabaseUrl = __api.env.SVELTE_APP_SUPABASE_URL
const supabaseAnonKey = __api.env.SVELTE_APP_SUPABASE_ANON_KEY

const site = window.location.host;
const tags = (new URLSearchParams(window.location.search).get('tags') || '').split(',');

const generateNewUser = () => {
  const userId = uuid();
  const userAutoPass = `${new Date() * 1}-${Math.random()}`;

  localStorage.setItem('userId', userId);
  localStorage.setItem('userAutoPass', userAutoPass);

  return {
    userId,
    userAutoPass,
  }
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
export const getUserId = async () => {
  if (navigator.userAgent.toLowerCase().includes('headless')) {
    return false
  }
  const session = supabase.auth.session()
  if (session) {
    return session.user.id
  }

  let userId = localStorage.getItem('userId');
  let userAutoPass = localStorage.getItem('userAutoPass');
  
  if (!(userId && userAutoPass)) {
    const newUser = generateNewUser();
    userId = newUser.userId
    userAutoPass = newUser.userAutoPass
  }

  const userData = {
    email: `hello+${userId}@mokshadata.com`,
    password: userAutoPass,
  }
  const signIn = await supabase.auth.signIn(userData)
  if (signIn.session) {
    return signIn.session.user.id
  }
  if (signIn.error) {
    const newUser = generateNewUser();
    userId = newUser.userId
    userAutoPass = newUser.userAutoPass
  }
  const signUp = await supabase.auth.signUp(
    userData,
    {
      data: {
        userId,
        userAgent: navigator.userAgent,
        language: navigator.language,
        site,
        tags,
      }
    }
  )
  if (signUp.session) {
    return signUp.session.user.id
  }
}